import { Notify } from 'quasar'
import { i18n } from 'src/boot/i18n'
import { QNotifyAction } from 'quasar/dist/types/api'
import { isCanceledError } from 'src/services/data/utils'

interface Info {
  message: string
  timeout?: number
  actions?: QNotifyAction[]
}

function handleActions(actions: QNotifyAction[]) {
  return actions.map((a) => {
    return {
      ...a,
      label: i18n.global.t(a.label as string),
    }
  })
}

export default class Notifier {
  static notifyFormError(error: { message: string }) {
    Notify.create({
      type: 'negative',
      position: 'top',
      message: error.message || i18n.global.t('error_general'),
    })
  }
  static notifyError(error: Error) {
    if (isCanceledError(error)) return
    Notify.create({
      type: 'negative',
      position: 'top',
      message: i18n.global.t(error.message),
    })
  }
  static notifyInfo(info: Info) {
    Notify.create({
      timeout: info.timeout ?? undefined,
      type: 'info',
      position: 'top',
      message: i18n.global.t(info.message),
      actions: info.actions ? handleActions(info.actions) : [],
    })
  }
}
